<template>
    <div>
        <div class="heading-travel-policy">
            <span :class="carPreferredVendorObj.isActive?'tag is-success':'tag'">Standard</span> 

                <div class="right-content">
                    <div class="lefttext">
                        <p class="paragrapgh">Rental company is not a preferred vendor</p>
                        <p>Trigger when the rental company is not a preferred vendor </p>
                    </div>
                    <div class="allbtns">
                        <b-switch 
                            :rounded="true" 
                            :value="carPreferredVendorObj.isActive" 
                            v-model="carPreferredVendorObj.isActive"
                            @input="carPreferredVendor" 
                            
                            >
                        </b-switch>
                    </div>
                </div>
            </div>
    </div>
</template>
<script>
export default{
    name:"",
    props: {
    value: {
      type: [Object],
    },
  },
    data(){
        return{
          carPreferredVendorObj:this.value?this.value:{
                    name: "carPreferredVendor",
                    isActive: false,
                    type:'car',
                    message:'',
          }
        }
    },
    methods:{
        carPreferredVendor(){
            this.$emit('carPreferredVendor',this.carPreferredVendorObj)
        }
    },
    mounted(){
        this.carPreferredVendorObj.type='car';
        this.carPreferredVendorObj.message=this.buildMessage;
        this.$emit('carPreferredVendor',this.carPreferredVendorObj)

    },
    computed:{
        buildMessage(){

            var string ='Trigger when the rental company is not a preferred vendor';

            return string;
        }
    },
    watch: {
    value: {
      handler(newVal, prevVal) {
        this.carPreferredVendorObj = this.value;
        this.carPreferredVendorObj.type='car';
        this.carPreferredVendorObj.message=this.buildMessage;
        this.$emit('carPreferredVendor',this.carPreferredVendorObj);
      },
      deep: true,
    },
  },
}
</script>